"use client";

import dynamic from "next/dynamic";
import Loading from "@/components/common/Loading";

const CommonAuth = dynamic(() => import("@/components/auth/CommonAuth"));
import { useAuth } from "@/hook/useAuth";
import Image from "next/image";
import Link from "next/link";
import { usePathname } from "next/navigation";

const AuthProvider = ({ children }: { children: React.ReactNode }) => {
  const pathName = usePathname();
  const protectedRoutes = ["/dashboard"];
  const { isAnonymous, loading } = useAuth();

  const isProtectedRoute = !!pathName && protectedRoutes.some((route) =>
    pathName.startsWith(route)
  );

  const shouldShowAuth =
    !loading && isAnonymous && isProtectedRoute;

  if (loading && isProtectedRoute) {
    return <Loading />;
  }

  if (shouldShowAuth) {
    return (
      <div className="z-99 fixed top-0 left-0 w-full h-full flex items-center justify-center bg-white">
        {/* <span className="absolute top-0 left-0 bg-black/60 w-full h-full z-10"></span> */}

        <div className="lg:w-[58%] max-w-[551px] mx-auto w-full lg:flex flex-col justify-center items-center p-5 py-5 bg-white z-20 rounded-xl shadow-xl">
          <Link
            href={"/"}
            className="max-w-[180px] sm:max-w-[230px] w-full mx-auto flex"
          >
            <Image
              priority
              className="w-full h-full betaRibbon"
              src="/logo/png/sideLogoDark.png"
              alt="logo"
              width={135}
              height={30}
            />
          </Link>

          <CommonAuth
            customArrowClassName={"!top-[-10%] sm:!top-[-12%] md:!top-[-15%]"}
          />
        </div>
      </div>
    );
  }

  return <>{children}</>;
};

export default AuthProvider;
